import "./src/styles/global.css"

import * as React from 'react'
import Prism from 'prism-react-renderer/prism';
(typeof global !== 'undefined' ? global : window).Prism = Prism;

require('prismjs/components/prism-dart');

export const wrapRootElement = ({ element }) => element
